/**
 * Created by neo on 26.02.17.
 */
import React, { Component } from 'react';
import { observable, computed } from 'mobx';
import { observer } from 'mobx-react';
import MediaGallery from './MediaGallery';
import { Col, Container, Row } from 'reactstrap';

type Props = {
  title: string,
  medias: Array<any>,
  subtitle: ?string,
};

@observer
export default class GalleryHeader extends React.Component<Props> {
  @observable galleryOpen: boolean = false;
  @observable imageIndex: number = 0;
  interval: any;

  static defaultProps = {
    medias: [],
  };

  constructor(props: Props) {
    super(props);
    this.imageIndex = Math.floor(Math.random() * this.props.medias.length);
  }

  componentDidMount() {
    this.interval = setInterval(() => {
      this.nextImageIndex();
    }, 7000);
  }

  componentWillUnmount() {
    clearTimeout(this.interval);
  }

  nextImageIndex() {
    this.imageIndex = (this.imageIndex + 1) % this.props.medias.length;
  }

  handleClick = () => {
    this.galleryOpen = true;
  };

  handleGalleryClose = () => {
    this.galleryOpen = false;
  };

  @computed
  get headerImage(): any {
    return (
      this.props.medias[this.imageIndex] && this.props.medias[this.imageIndex].file || {
        url: 'https://placeholdit.imgix.net/~text?txtsize=33&txt=350%C3%97150&w=350&h=150',
        mime_type: 'image/jpeg',
      }
    );
  }

  render() {
    const { headerImage, galleryOpen, props: { medias, title, subtitle, location } } = this;
    if (headerImage.mime_type.startsWith('image')) {
      const style = { backgroundImage: `url('${headerImage.url}')` };

      return (
        <div>
          <Container>
            <h1 style={{marginBottom:0}}> {title}</h1>
            {subtitle ? <span>{subtitle}</span> : null}

            <Row className='mt-4'>
              <Col md={12} style={{ display: 'flex' }}>
                <div className='flight-offer-header' style={style} onClick={this.handleClick}>
                </div>
              </Col>
            </Row>
          </Container>
          <MediaGallery medias={medias.map(m => m.file)} open={galleryOpen} onClose={this.handleGalleryClose} />
        </div>
      );
    } else if (headerImage.mediaType.startsWith('video')) {
      return (
        <Container>
          <h1 style={{marginBottom:0}}> {title}</h1>
          {subtitle ? <span>{subtitle}</span> : null}

          <Row className='mt-1'>
            <Col md={12} style={{ display: 'flex' }}>
              <div className="flight-offer-header" onClick={this.handleClick}>
                <div className="embed-responsive embed-responsive-16by9 video">
                  <video playsInline autoPlay muted loop>
                    <source src={headerImage.url} type={headerImage.mime_type} />
                  </video>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
    )
      ;
    }
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/App/Components/GalleryHeader/index.js